




























































































































































/** @format */
import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import { Getter } from 'vuex-class';
// 下拉框封装组件
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import {
  sendRecordPageList,
  sendRecordExport,
  sendRecordTime,
  sendRecordTimeExport
} from '@/api/discount-management/index';
import Utils from '@root/utils/common';
import ParkingReviewImage from '@/components/parking-review-image/index.vue';
import moment from 'moment';
import { couponTypeMap, couponFromMap, sendCouponMap } from '@/types/discount-management/dictionaries';
import PlateInput from '@/components/plate-input/index.vue';
import * as _ from 'lodash';
import * as routeNames from '@/views/order-management/router-names';
import OrganizationSearch from '@/components/organization-search/index.vue';
import CountCardSimpleGrid from '@/components/count-card/simple-grid.vue';
@Component({
  name: 'CouponSendList',
  components: { ParkingLotSearch, ParkingReviewImage, PlateInput, OrganizationSearch, CountCardSimpleGrid }
})
export default class CouponSendList extends Mixins(TableMixin, TableWidthMixin) {
  private filterParam: any = {
    parkIds: [], //选中的车场
    merchantName: '',
    types: [],
    plate: '',
    startDate: moment(new Date()).format('YYYY-MM-DD'), // 开始时间
    endDate: moment(new Date()).format('YYYY-MM-DD'), // 结束时间
    parkTypes: '',
    // orgId: '',
    sendType: '',
    resourceType: '',
    couponName: ''
  };
  plateInputModel = false;
  // options = _.filter(
  //   Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_coupon_coupon_type),
  //   function(o) {
  //     return o.value != '04';
  //   }
  // );
  options = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_coupon_coupon_type);
  // 车场业态选项
  // @Getter('dictionaries/parkType')
  // parkTypeMap?: object
  // get parkTypeOptions(): any[] {
  //   return Utils.toLabelVal(this.parkTypeMap)
  // }
  parkTypeOptions = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_biz_type);
  // options = Utils.toLabelVal(couponTypeMap)
  private tableLoading: boolean = false;
  tableData: any[] = [];
  totalCount: any[] = []; //汇总
  plateHead = '';
  plateTail = '';
  // 查看图片弹框
  showReviewImgModel: boolean = false;
  imgPath = '';
  formData = {
    avatar: require('@/assets/images/error.png')
  };
  //优惠来源列表
  couponFromList = Utils.toLabelVal(couponFromMap) || [];
  //发券方式
  sendCouponList =
    Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_coupon_record_send_type || {}) || [];

  //搜索时间配置
  private onTimeChange(date: any, dateString: any) {
    let [operateTimeStart, operateTimeEnd] = dateString;
    this.filterParam.startDate = operateTimeStart;
    this.filterParam.endDate = operateTimeEnd;
  }
  isSDShangYe: boolean = 'sdshangye,testing,development,release'.includes(
    // @ts-ignore
    window.VUE_APP_SERVER_CONFIG.APP_ENV
  );
  get defaultTime() {
    if (this.filterParam.startDate && this.filterParam.endDate) {
      return [
        this.moment(this.filterParam.startDate, 'YYYY-MM-DD'),
        this.moment(this.filterParam.endDate, 'YYYY-MM-DD')
      ];
    } else if (this.filterParam.startDate) {
      return [this.moment(this.filterParam.startDate, 'YYYY-MM-DD')];
    } else {
      return [];
    }
  }
  set defaultTime(val: any) {}
  private moment = moment;
  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }
  //table列表
  get tableColums() {
    if (this.isSDShangYe)
      return [
        {
          title: '序号',
          width: 55,
          customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
        },
        {
          title: '所属机构(项目)',
          dataIndex: 'orgDepName',
          width: 180,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '业态',
          dataIndex: 'parkType',
          width: 180,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '项目名称',
          dataIndex: 'projectName',
          width: 180,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '所属车场',
          dataIndex: 'parkName',
          width: 180,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '商户名称',
          dataIndex: 'merchantName',
          width: 180,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '停车订单号',
          dataIndex: 'orderId',
          width: 320,
          scopedSlots: { customRender: 'orderId' }
        },
        {
          title: '优惠券名称',
          dataIndex: 'name',
          width: 180,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '优惠券类型',
          dataIndex: 'type',
          width: 180,
          customRender: (text: any) => text || '--'
        },
        {
          title: '优惠数额',
          dataIndex: 'value',
          width: 140,
          customRender: (text: any) => text || '--'
        },
        {
          title: '优惠券号',
          dataIndex: 'detailId',
          width: 320,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '车牌号',
          dataIndex: 'plate',
          width: 120,
          customRender: (text: any) => text || '--'
        },
        {
          title: '发放时间',
          dataIndex: 'sendTime',
          width: 200,
          customRender: (text: any) => text || '--'
        },
        {
          title: '到期时间',
          dataIndex: 'failureDate',
          width: 200,
          customRender: (text: any) => text || '--'
        },
        {
          title: '发放人',
          dataIndex: 'sendBy',
          width: 140,
          scopedSlots: { customRender: 'text-ellipse-12' }
        },
        {
          title: '优惠来源',
          dataIndex: 'resourceType',
          width: 140,
          scopedSlots: { customRender: 'resourceType' }
        },
        {
          title: '发券方式',
          dataIndex: 'sendType',
          width: 160,
          scopedSlots: { customRender: 'sendType' }
        },
        {
          title: '发券凭证',
          dataIndex: 'imgPath',
          width: 140,
          scopedSlots: { customRender: 'viewImg' }
        },
        {
          title: '下发状态',
          dataIndex: 'sendLocalStatus',
          width: 140,
          customRender: (text: any) => text || '--'
        }
      ];
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '所属机构',
        dataIndex: 'orgDepName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '业态',
        dataIndex: 'parkType',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '项目名称',
        dataIndex: 'projectName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '所属车场',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '商户名称',
        dataIndex: 'merchantName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '停车订单号',
        dataIndex: 'orderId',
        width: 320,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '优惠券名称',
        dataIndex: 'name',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '优惠券类型',
        dataIndex: 'type',
        width: 180,
        customRender: (text: any) => text || '--'
      },
      {
        title: '优惠数额',
        dataIndex: 'value',
        width: 140,
        customRender: (text: any) => text || '--'
      },
      {
        title: '优惠券号',
        dataIndex: 'detailId',
        width: 320,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车牌号',
        dataIndex: 'plate',
        width: 120,
        customRender: (text: any) => text || '--'
      },
      {
        title: '发放时间',
        dataIndex: 'sendTime',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '到期时间',
        dataIndex: 'failureDate',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '发放人',
        dataIndex: 'sendBy',
        width: 140,
        scopedSlots: { customRender: 'text-ellipse-12' }
      },
      {
        title: '下发状态',
        dataIndex: 'sendLocalStatus',
        width: 140,
        customRender: (text: any) => text || '--'
        //scopedSlots: { customRender: 'sendLocalStatus' },
      },
      {
        title: '查看图片',
        dataIndex: 'imgPath',
        width: 140,
        fixed: 'right',
        scopedSlots: { customRender: 'viewImg' }
      }
    ];
  }
  //table初始化
  async fetchTableData(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      const { parkIds, types, ...rest } = this.filterParam;
      const { status, code, msg, data } = await sendRecordPageList({
        ...rest,
        types: this.filterParam.types.join(','),
        parkIds: this.filterParam.parkIds.join(','),
        page: this.current,
        pageSize: this.pageSize
      });
      const {
        datas,
        totalNum,
        totalPage,
        currPage,
        pageSize,
        durationCouponCount,
        moneyCouponCount,
        freeCouponCount,
        timeFrameCouponCount,
        discountCouponCount,
        allCouponCount
      } = data;
      this.tableData = datas;
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
      this.totalCount = [];
      this.totalCount.push(
        { title: '全部（张）', count: allCouponCount || 0, countColor: 'warning' },
        { title: '金额优惠（张）', count: moneyCouponCount || 0, countColor: 'primary' },
        { title: '时长优惠（张）', count: durationCouponCount || 0, countColor: 'primary' },
        { title: '单次免费（张）', count: freeCouponCount || 0, countColor: 'primary' },
        { title: '限时免费（张）', count: timeFrameCouponCount || 0, countColor: 'primary' },
        { title: '折扣优惠（种）', count: discountCouponCount || 0, countColor: 'primary' }
      );
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  async fetchTableDataSY(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      const { parkIds, types, ...rest } = this.filterParam;
      const { status, code, msg, data } = await sendRecordTime({
        ...rest,
        types: this.filterParam.types.join(','),
        parkIds: this.filterParam.parkIds.join(','),
        page: this.current,
        pageSize: this.pageSize
      });
      const { datas, totalNum, totalPage, currPage, pageSize, total } = data;
      // @ts-ignore
      const { durationCouponCount, moneyCouponCount, freeCouponCount, timeFrameCouponCount, allCouponCount } =
        total || {};
      this.tableData = datas;
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
      this.totalCount = [];
      this.totalCount.push(
        { title: '全部（张）', count: allCouponCount || 0, countColor: 'warning' },
        { title: '金额优惠（张）', count: moneyCouponCount || 0, countColor: 'primary' },
        { title: '时长优惠（张）', count: durationCouponCount || 0, countColor: 'primary' },
        { title: '单次免费（张）', count: freeCouponCount || '-', countColor: 'primary' },
        { title: '限时免费（张）', count: timeFrameCouponCount || '-', countColor: 'primary' }
      );
    } catch (error) {
      console.log(error);
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  //分页
  handleTableChange(val: any) {
    this.current = val.current;
    this.pageSize = val.pageSize;
    this.initTable();
  }
  //点击搜索
  searchTable() {
    this.initTable(true);
  }
  //清空table
  onTableFilterClear({ defaultParkIdList }) {
    this.plateInputModel = true;
    this.filterParam = {
      parkIds: defaultParkIdList, //选中的车场
      merchantName: '',
      types: [],
      plate: '',
      startDate: moment(new Date()).format('YYYY-MM-DD'), // 开始时间
      endDate: moment(new Date()).format('YYYY-MM-DD'), // 结束时间
      parkTypes: '',
      // orgId: '',
      sendType: '',
      resourceType: '',
      couponName: ''
    };
    this.$nextTick(() => {
      this.initTable();
    });
  }
  // 车牌改变
  plateChange([plateHead, plateTail]: any, b: any) {
    this.filterParam.plate = plateHead + plateTail;
  }
  get reviewColums() {
    return [
      {
        imageSrc: 'imgPath',
        data: '车牌-plate'
          .split(' ')
          .map(item => ((arguments[0] = item.split('-')), { label: arguments[0][0], dataIndex: arguments[0][1] }))
      }
    ];
  }
  //导出
  private async downLoad() {
    if (this.isSDShangYe) {
      try {
        const { parkIds, types, ...rest } = this.filterParam;
        await sendRecordTimeExport(
          {
            ...rest,
            types: this.filterParam.types.join(','),
            parkIds: this.filterParam.parkIds.join(','),
            currPage: this.current,
            pageSize: this.pageSize
          },
          '优惠券发放记录'
        );
      } catch (e) {
        console.log(e);
        console.log('couponExport', '导出失败');
      }
    } else {
      try {
        const { parkIds, types, ...rest } = this.filterParam;
        await sendRecordExport(
          {
            ...rest,
            types: this.filterParam.types.join(','),
            parkIds: this.filterParam.parkIds.join(','),
            currPage: this.current,
            pageSize: this.pageSize
          },
          '优惠券发放记录'
        );
      } catch (e) {
        console.log('couponExport', '导出失败');
      }
    }
  }
  // 查看图片
  reviewImages(record: any) {
    this.imgPath = record.imgPath;
    this.showReviewImgModel = true;
  }
  //初始化table列表
  initTable(flag: boolean = false) {
    if (this.isSDShangYe) {
      this.fetchTableDataSY(flag);
    } else {
      this.fetchTableData(flag);
    }
  }
  created() {
    this.$nextTick(() => {
      this.initTable();
    });
  }
  isOrgRoot: boolean = true;
  //默认选中机构根节点
  selectDefaultRoot(val) {
    this.filterParam.orgId = val;
    console.log('默认选中机构根节点', this.filterParam.orgId);
  }
  //获取发券方式
  getsendCoupon(value) {
    let a = [];
    if (value) {
      a = _.filter(this.sendCouponList, function(o) {
        return o.value == value;
      });
      return a.length > 0 ? a[0].label : '--' || '--';
    }
    return '--';
  }
  /**
   * 跳转订单详情页面
   */
  toParkOrderDetail(obj: any) {
    const { parkId, orderId: pkOrderId } = obj;
    this.$router.push({
      name: routeNames.PARKING_RECORD_DETAIL,
      params: {
        parkId,
        pkOrderId
      }
    });
  }
}
